<template>
  <client-only>
    <v-checkbox
      v-model="rememberMe"
      color="orange"
      class="mt-0"
      hide-details
      light
      label="זכור אותי"
      dense
    />
  </client-only>
</template>

<script>
export default {
  data() {
    return {
      rememberMe: true,
    };
  },
  watch: {
    rememberMe() {
      this.applyRememberMe();
    },
  },
  methods: {
    applyRememberMe() {
      this.$emit("checked", this.rememberMe);
    },
  },
};
</script>
